// extracted by mini-css-extract-plugin
export default {"header":"app-header_header__joE2Z","body":"app-header_body__4NRI9","logo":"app-header_logo__NoRyC"};